<template>
  <v-row>
    <v-col cols="12" class="mx-auto" interviews>
      <v-card class="elevation-0">
        <Paging
          :resourceSettings="resourceSettings"
          :resource="calls"
          @loadResource="loadResource"
          @pageByNumber="pageByNumber"
        />
        <v-card-text>
          <v-row>
            <v-col md="4" cols="12" FILTERS>
                <v-autocomplete
                  @change="applyFilter"
                  label="Answered"
                  autocomplete="disabled"
                  outlined
                  dense
                  v-model="answered"
                  :items="statuses"
                  :class="`${arabic?'arFont':'enFont'}`"
                />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="1" class="mx-auto">
              <v-btn block @click.stop="$emit('openDialog', 'call')" color="primary">
                {{ i18n.new }}
              </v-btn>
            </v-col>
          </v-row>
          <v-timeline v-if="calls.data && calls.data.length > 0" dense clipped>
            <v-timeline-item
              v-for="(call, key) in calls.data"
              :key="`call-${key}`"
              :color="call.answered ? 'success' : 'red'"
              icon-color="grey lighten-2"
              small
            >
              <v-row justify="space-between" class="align-center elevation-2">
                <v-col cols="12">
                  <div :class="`${arabic ? 'arFont' : 'enFont'} mb-1`" style="font-size:11px;font-weight:700;">
                    {{ i18n.call_by }}
                  </div>
                  <v-chip dark color="info" label small :class="`${arabic ? 'arFont' : 'enFont'}`">
                    {{ call.employee_name.name }}
                  </v-chip>
                </v-col>
                <v-col cols="6" class="pt-0">
                  <div :class="`${arabic ? 'arFont' : 'enFont'} mb-1`" style="font-size:11px;font-weight:700;">
                    {{ i18n.note }}
                  </div>
                  <div :class="`${arabic ? 'arFont' : 'enFont'} mb-1`">{{ call.note }}</div>
                  <div :class="`${arabic ? 'arFont' : 'enFont'}`">
                    <strong>{{ i18n["status"] }}: </strong>
                    <span v-if="call.answered">{{ i18n["answered"] }}</span>
                    <span v-else>{{ i18n["unanswered"] }}</span>
                  </div>
                </v-col>
                <v-col cols="6" class="pt-0">
                  <div :class="`${arabic ? 'arFont' : 'enFont'}`" style="font-size:11px;font-weight:700;">
                    {{ i18n.last_update }}
                  </div>
                  <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ getFormat(call.created_at) }}</div>
                </v-col>
                <v-col cols="12" class="pt-0">
                  <v-row>
                    <v-col class="py-0">
                      <div>
                        <v-btn small @click.prevent="$emit('editResource', 'call', call)" class="mr-2" color="primary">
                          Edit
                        </v-btn>
                        <v-btn small @click.prevent="$emit('deleteResource', 'call', call)" color="error">Delete</v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import Paging from "@/components/Paging";
import { format } from "timeago.js";

export default {
  props: ["calls"],
  components: { Paging },
  data() {
    return {
      page: 1, 

      statuses: [
        {
          text: 'All',
          value: null,
        },
        {
          text: 'Yes',
          value: true,
        },
        {
          text: 'No',
          value: false,
        },
      ],

      answered: null,

      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
    };
  },
  computed: {
    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
    arabic() {
      if (this.$store.state.language == "ar") return true;
    },
  },
  methods: {
    buildFilter() {
      let filter = ``

      if(this.answered != null) {
        filter += `&answered=${this.answered}`
      }

      return filter;
    },
    applyFilter() {
      this.loadResource()
    },
    getFormat(d) {
      return format(d);
    },
    loadResource() {
      this.$emit("loadResource", "calls", "calls", this.buildFilter(), this.page);
    },
    pageByNumber(page) {
      this.page = page
      this.$emit("pageByNumber", "calls", "calls", page);
    },
  },
};
</script>
